import { render, staticRenderFns } from "./ProfileBanner.vue?vue&type=template&id=a431aeb8&scoped=true&"
import script from "./ProfileBanner.vue?vue&type=script&lang=js&"
export * from "./ProfileBanner.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBanner.vue?vue&type=style&index=0&id=a431aeb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a431aeb8",
  null
  
)

export default component.exports